import { Amplify } from "aws-amplify";
import { loadCloudConfig } from "@models/storage/cloudConfig";

/**
 * Amplify v6 bootstrap.
 *
 * Cognito settings come from the same environment-keyed CloudConfig as
 * DynamoDB, S3, GraphQL, and realtime sessions. This prevents a production
 * build from authenticating against the development user/identity pools.
 *
 * `allowGuestAccess` mirrors Grill so the unauthenticated landing page
 * (and any pre-login telemetry) can fetch identity-pool credentials
 * before the user signs in.
 */

let configured = false;

/**
 * Idempotent — safe to call multiple times. The first call wins; later
 * calls are no-ops, so test setups can pre-configure with overrides
 * before the model bootstraps.
 */
export function configureAmplify(): void {
  if (configured) return;
  configured = true;
  const config = loadCloudConfig();

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        identityPoolId: config.identityPoolId,
        allowGuestAccess: true,
        loginWith: {
          email: true,
          username: false,
          phone: false,
        },
      },
    },
  });
}
